import { createSlice } from "@reduxjs/toolkit";
import { fetchAssociateSuggestion, fetchAssociationList, deleteAssociationList, updateAssociationList } from "./AssociationActions";
import { getApiErrorMessage } from "../../utils/commonUtilities";

const providerExpAssSuggestion = createSlice({
    name: "associationSuggestion",
    initialState: {
      isAssSuggestLoading: false,
      assSuggestData: [],
      assSuggestError: null,
      assSuggestErrmsg: ""
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(fetchAssociateSuggestion.pending, (state) => {
          state.isAssSuggestLoading = true;
          state.error = null;
        })
        .addCase(fetchAssociateSuggestion.fulfilled, (state, action) => {
          if(!action.payload.success){
            state.isAssSuggestLoading = false;
            state.assSuggestError = true;
            state.assSuggestErrmsg = getApiErrorMessage(action.payload.status);
          }
          else{
            state.isAssSuggestLoading = false;
            state.assSuggestData = action.payload?.data?.data?.associationResponseDTO?.items;
          }
        })
        .addCase(fetchAssociateSuggestion.rejected, (state, action) => {
          state.isAssSuggestLoading = false;
          state.assSuggestError = action.error.message;
        });
    },
  });
  
  const providerExpAssociationList = createSlice({
    name: "expassociationList",
    initialState: {
      isAssListstLoading: false,
      assListData: [],
      assListError: null,
      assErrorMsg: "",
      isAssDeletestLoading: false,
      assDeleteMsgError:"",
      assDeleteError: null
    },
    reducers: {
      addProviderAssociation: (state, action) => {
        state.assListData = action.payload;
      },
      deleteProviderAssociation: (state, action) => {
         const { displayId } = action.payload;
        const updatedAssociation = action.payload.assListData.filter((asItem) => {
          return asItem.displayId !== displayId;
        });
        state.assListData = updatedAssociation;
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(fetchAssociationList.pending, (state) => {
          state.isAssListstLoading = true;
          state.error = null;
        })
        .addCase(fetchAssociationList.fulfilled, (state, action) => {
          state.isAssListstLoading = false;
          if(!action.payload.success){
            if (
              action.payload.data.metadata?.outcome.additionalDetails[0]
                ?.additionalInfo
            ){
              state.assListError = false;
              state.assListData = [];
              state.isAssListstLoading = false;
            } else {
            state.assListError = true;
            state.assErrorMsg = getApiErrorMessage(action.payload.status);
          }
        }
          else{
            state.assListError = false;
            state.assListData = action.payload.data.data.providerAssociationResponseDTO;
          }
        })
        .addCase(fetchAssociationList.rejected, (state, action) => {
          state.isAssListstLoading = false;
          state.assListError = action.error.message;
        });
        builder
        .addCase(deleteAssociationList.pending, (state) => {
          state.isAssDeletestLoading = true;
        })
        .addCase(deleteAssociationList.fulfilled, (state, action) => {
          state.isAssListstLoading = false;
          if(!action.payload.success){
            state.isAssDeletestLoading = false;
            state.assDeleteError = true;
            state.assErrorMsg = getApiErrorMessage(action.payload.status);
          }
          else{
            state.isAssDeletestLoading = false;
            state.assDeleteError = false;
          }
        })
        .addCase(deleteAssociationList.rejected, (state) => {
          state.isAssDeletestLoading = true;
          state.assDeleteMsgError = "Something Went Wrong!. Please try again later.";
        });
        builder
        .addCase(updateAssociationList.pending, (state) => {
          state.isAssListstLoading = true;
          state.error = null;
        })
        .addCase(updateAssociationList.fulfilled, (state, action) => {
          state.isAssListstLoading = false;
          if(!action.payload.success){
            state.assListError = true;
            state.assErrorMsg = getApiErrorMessage(action.payload.status);
          }
          else{
            state.assListError = false;
          }
        })
        .addCase(updateAssociationList.rejected, (state, action) => {
          state.isAssListstLoading = false;
          state.assListError = action.error.message;
        });
    },
  });

export const { addProviderAssociation, deleteProviderAssociation } =
  providerExpAssociationList.actions;
export const providerExpAssociationReducer = providerExpAssSuggestion.reducer;
export const providerExpAssociationListReducer = providerExpAssociationList.reducer;